
import { logUtil,typeUtil,objUtil } from "@repo/lib-common";




export class AffiliateParams  {


    offerId: typeUtil.StringOrUndefined;
    transactionId: typeUtil.StringOrUndefined;
    eventId:typeUtil.StringOrUndefined;
    referrer: typeUtil.StringOrUndefined;
    utmCampaign: typeUtil.StringOrUndefined;
    utmMedium: typeUtil.StringOrUndefined;
    utmSource: typeUtil.StringOrUndefined;
    utmContent: typeUtil.StringOrUndefined;
    utmTerm: typeUtil.StringOrUndefined;

}

export function validateAffliateParams(data:AffiliateParams|undefined):boolean{
    if(objUtil.isObjNullOrUndefined(data)) {
        logUtil.consoleError("affiliate params are undefined");
        return false;
    }
    if(objUtil.isNullOrEmpty(data!.transactionId)) {
        logUtil.consoleError("affiliate params transactionId is undefined");
        return false;
    }
    if(objUtil.isNullOrEmpty(data!.offerId)) {
        logUtil.consoleError("affiliate params offerId is undefined");
        return false;
    }
    return true;
}


